import { useEffect, useState } from 'react';
import { Alert } from 'antd';
import apiClient from '@/api/client';

interface EnvInfo {
  show_banner: boolean;
  message: string;
}

const EnvBanner: React.FC = () => {
  const [envInfo, setEnvInfo] = useState<EnvInfo | null>(null);

  useEffect(() => {
    apiClient.get<EnvInfo>('/env-info/').then((r) => setEnvInfo(r.data)).catch(() => {});
  }, []);

  if (!envInfo?.show_banner) return null;

  return (
    <Alert
      title={<strong style={{ color: '#cf1322' }}>{envInfo.message}</strong>}
      type="error"
      banner
      showIcon={false}
      closable={false}
      style={{ textAlign: 'center' }}
    />
  );
};

export default EnvBanner;
